import styled, { css } from "styled-components";

import Loader from "components/Layout/Loader";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  width: 418px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  margin-top: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const SearchControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-left: 32px;
`;

export const SearchControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-right: 6px;
  &:not(:last-child) {
    margin-bottom: 12px;
  }

  min-height: 54px;

  padding: 6px;

  border-radius: 8px;
  border: 2px solid transparent;
  background-color: ${COLORS.BACKGROUND};

  ${({ checked }: { checked?: boolean }) =>
    checked &&
    css`
      border: 2px solid ${COLORS.CYAN};
      background-color: ${COLORS.BACKGROUND};
    `}
`;

export const QuestionInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const MovementImage = styled.div`
  min-width: 60px;
  min-height: 60px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const QuestionText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 0 10px;
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;
